'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".Banner-module_banner__1vplH{border:1px solid;border-radius:4px;box-sizing:border-box;padding:1rem}";
var styles = {"banner":"Banner-module_banner__1vplH"};
styleInject["default"](css_248z, 'ae187d0b-41d6-4ecc-880a-3f5f13174b97');

exports["default"] = styles;
